import { createUseStyles } from 'react-jss';

import { ErrorColors } from '@picsart/design-system/foundation/colors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    // Icon over label, matching the feed rail's own buttons. The column and gap
    // are inert for the bare placements, which render no label.
    likeButton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s4,
      padding: 0,
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      color: 'inherit',
    },
    // Constant "Like" rather than a liked/unliked swap — the rail's Save reads
    // the same way, and only the icon carries state.
    likeLabel: {
      fontSize: FontSizes.t3,
      fontWeight: FontWeights.medium,
    },
    likeIcon: {
      width: Spacings.s32,
      height: Spacings.s32,
    },
    // The `card` placement is a DS `InlineButton`, so its box and glyph come
    // from the host's class and `size="small"` — only the liked colour is ours.
    // Set on the button so the icon picks it up through `currentColor`.
    cardLiked: {
      color: ErrorColors.base.default,
    },
    likeIconLiked: {
      color: ErrorColors.base.default,
    },
  },
  { name: 'preset-like-button' }
);

export default useStyles;
